"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataExplorerTemplateName = exports.DataExplorerFilterOperator = exports.DataExplorerFilterField = exports.DataExplorerSortDirection = exports.DataExplorerFieldType = exports.MetricEnum = void 0;
var MetricEnum;
(function (MetricEnum) {
    MetricEnum["Visitors"] = "visitors";
    MetricEnum["Sessions"] = "sessions";
})(MetricEnum = exports.MetricEnum || (exports.MetricEnum = {}));
var DataExplorerFieldType;
(function (DataExplorerFieldType) {
    DataExplorerFieldType["Dimension"] = "DIMENSION";
    DataExplorerFieldType["Metric"] = "METRIC";
    DataExplorerFieldType["Filter"] = "FILTER";
    DataExplorerFieldType["MetricFilter"] = "METRIC_FILTER";
})(DataExplorerFieldType = exports.DataExplorerFieldType || (exports.DataExplorerFieldType = {}));
var DataExplorerSortDirection;
(function (DataExplorerSortDirection) {
    DataExplorerSortDirection["Asc"] = "ASC";
    DataExplorerSortDirection["Desc"] = "DESC";
})(DataExplorerSortDirection = exports.DataExplorerSortDirection || (exports.DataExplorerSortDirection = {}));
var DataExplorerFilterField;
(function (DataExplorerFilterField) {
    DataExplorerFilterField["EventAction"] = "eventAction";
    DataExplorerFilterField["Affiliation"] = "affiliation";
    DataExplorerFilterField["Url"] = "url";
})(DataExplorerFilterField = exports.DataExplorerFilterField || (exports.DataExplorerFilterField = {}));
var DataExplorerFilterOperator;
(function (DataExplorerFilterOperator) {
    DataExplorerFilterOperator["Equal"] = "EQUAL";
    DataExplorerFilterOperator["Contains"] = "CONTAINS";
    DataExplorerFilterOperator["Regexp"] = "REGEXP";
    DataExplorerFilterOperator["Ignore"] = "IGNORE";
})(DataExplorerFilterOperator = exports.DataExplorerFilterOperator || (exports.DataExplorerFilterOperator = {}));
var DataExplorerTemplateName;
(function (DataExplorerTemplateName) {
    DataExplorerTemplateName["Nps"] = "nps";
    DataExplorerTemplateName["Csat"] = "csat";
    DataExplorerTemplateName["CsatComments"] = "csat-comments";
    DataExplorerTemplateName["CsatQuestions"] = "csat-questions";
    DataExplorerTemplateName["CsatScores"] = "csat-scores";
    DataExplorerTemplateName["CsatRatings"] = "csat-events-by-value";
    DataExplorerTemplateName["CsatTotals"] = "csat-totals";
    DataExplorerTemplateName["MonitoringGraphBounceRate"] = "monitoring-graph-bounce-rate";
    DataExplorerTemplateName["MonitoringGraphPagePerSession"] = "monitoring-graph-page-per-session";
    DataExplorerTemplateName["MonitoringGraphRevisitRate"] = "monitoring-graph-revisit-rate";
    DataExplorerTemplateName["MonitoringGraphPage"] = "monitoring-graph-page";
    DataExplorerTemplateName["MonitoringGraphEvents"] = "monitoring-graph-events";
    DataExplorerTemplateName["MonitoringGraphTransactions"] = "monitoring-graph-transactions";
})(DataExplorerTemplateName = exports.DataExplorerTemplateName || (exports.DataExplorerTemplateName = {}));
//# sourceMappingURL=types.js.map